<template>
  <div>
    <h2 class="m-b-20 section-title">{{ label }}</h2>
    <div class="card m-b-40">
      <div class="row">
        <div>
          <GoodsType
            :value="1"
            @activeGoodsType="activeGoodsType"
          />
        </div>
      <!-- PACKAGE OPTIONS -->
      <div v-if="showColliContent">
        <div class="row m-b-25">
          <div class="col-xs-1" v-if="showColliAmount">
            <InputText
              :label="$t('Colli')"
              v-model="value.colli"
              :rules="{required: true}"
            />
          </div>
          <div class="col-xs-3">
            <NestedSelect
              v-if="get_parcel_types[1] != null"
              :label="$t('packaging')"
              @parcelTypeSelected="parcelTypeSelected"
              :getter="get_parcel_types[1]"
              v-model="value.parcelType" />
          </div>
          <div :class="'col-xs-6'">
            <DimensionsSelect
              v-model="value.dimensions" />
          </div>
          <div :class="showColliAmount ? 'col-xs-2' : 'col-xs-3'">
            <WeightSelect
              :label="`${$t('weight_per')} ${$t('parcel').toLocaleLowerCase()}`"
              v-model="value.colliWeight"
              :rules="{required: true}"/>
          </div>
        </div>
        <div v-if="showColliDescription" class="row m-b-25">
          <div :class="'col-xs-12'">
            <DescriptionPicker
              :label="$t('desc')"
              v-model="value.description"
            />
          </div>
        </div>
        <div class="separator"></div>
        <!-- CONTENT ROW -->
        <div class="row m-b-40">
          <h2 class="col-xs-12 content-title m-b-20">{{ $t('content_title_parcel') }}</h2>
          <div class="col-xs-12">
            <ContentRow
              :class="value.content.length > (index + 1) ? 'm-b-20' : ''"
              :showOnlyDescription="showOnlyDescription"
              :showOrigin="showOrigin"
              :showCustoms="showCustoms"
              :isCustomsInvoiceUploaded="isCustomsInvoiceUploaded"
              v-for="(item, index) in value.content" :key="`parcel-content-${index}`"
              :deletable="value.content.length > 1"
              :indexInData="index"
              @setProductDetails="productSelected"
              @removeProduct="productRemoved"
              @quantityChange="quantityChange"
              @deleteRow="deleteContentRow(index)"
              v-model="value.content[index]"
            />
          </div>
        </div>
      </div>
      <div v-if="!showColliContent">
        <div class="row m-b-25">
          <div class="col-xs-1" v-if="showColliAmount">
            <InputText
              :label="$t('Colli')"
              v-model="value.colli"
              :rules="{required: true}"
            />
          </div>
          <div class="col-xs-3">
            <NestedSelect
              v-if="get_parcel_types[1] != null"
              :label="$t('packaging')"
              @parcelTypeSelected="parcelTypeSelected"
              :getter="get_parcel_types[1]"
              v-model="value.parcelType" />
          </div>
          <div :class="'col-xs-6'">
            <DimensionsSelect
              v-model="value.dimensions" />
          </div>
          <div :class="showColliAmount ? 'col-xs-2' : 'col-xs-3'">
            <WeightSelect
              :label="`${$t('weight_per')} ${$t('parcel').toLocaleLowerCase()}`"
              v-model="value.colliWeight"
              :rules="{required: true}"/>
          </div>
        </div>
        <div v-if="showColliDescription" class="row m-b-25">
          <div :class="'col-xs-12'">
            <DescriptionPicker
              :label="$t('desc')"
              v-model="value.description"
            />
          </div>
        </div>
      </div>
      <div class="separator" v-if="removable"></div>
      <!-- CONTENT ROW OPTIONS -->
      <div class="clear-float">
        <div class="col-xs-6">
          <Btn v-if="showColliContent"
               @click.native="addContentItem"
               class="brand float-left m-r-20"
               :icon="{
            name: 'plus',
            size: '20',
          }"
               :btnText="$t('Add content')"
          />
          <Btn
            v-if="removable"
            @click.native="removeParcel"
            class="gray float-left m-r-20"
            :icon="{
            name: 'deleteForever',
            size: '18',
          }"
            :btnText="$t('Remove parcel')"
          />
        </div>
        <div
          v-if="!useContentOnShipmentLevel && value.content[0]"
          class="col-xs-6 float-right"
          style="text-align: right; padding-top: 5px">
          <p>{{ $t('total_value')}} {{ totalContentAmount | currency(null, value.content[0].unitValue.unit.toUpperCase()) }}</p>
        </div>
      </div>

      <booking-dg-block
        v-if="!useContentOnShipmentLevel"
        :value="value"
        :custom-id="customId"
        :dg-type-shown-on-package-custom-id="dgTypeShownOnPackageCustomId"
        :show-temperature="showTemperature"
        :show-dangerous-goods="showDangerousGoods"
        @input="$emit('input', $event)"
      />
    </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { mapGetters } from "vuex";
import mixin from '@/mixins/mixins.js';
import Btn from '@/components/elements/buttons';
import InputText from '@/components/elements/inputs/text.vue';
import InputSelect from '@/components/elements/inputs/select.vue';
import NestedSelect from '@/components/elements/inputs/nestedSelect.vue';
import DimensionsSelect from '@/components/elements/inputs/dimensionsSelect.vue';
import WeightSelect from '@/components/elements/inputs/weightSelect.vue';
import Toggle from "@/components/elements/inputs/toggle.vue";

import ContentRow from "@/components/shipments/contentRow.vue";
import DangerousGoodsBlock from "@/components/shipments/dangerousGoodsBlock";
import GoodsType from "@/components/shipments/goodsType.vue";
import ProductPicker from "@/components/global/productPicker/productPicker.vue";
import productSelect from "@/mixins/productSelect";
import BookingDgBlock from "@/components/shipments/bookingDgBlock.vue";
import DescriptionPicker from "@/components/global/productPicker/descriptionPicker.vue";

export default {
  name: 'ParcelBlock',
  mixins: [mixin, productSelect],
  components: {
    DescriptionPicker,
    BookingDgBlock,
    ProductPicker,
    GoodsType,
    Btn,
    InputSelect,
    InputText,
    Toggle,
    DimensionsSelect,
    WeightSelect,
    ContentRow,
    NestedSelect,
    DangerousGoodsBlock
  },
  props: {
    useContentOnShipmentLevel: {
      type: Boolean,
      default: true,
    },
    isCustomsInvoiceUploaded: {
      type: Boolean,
      default: false,
    },
    dgTypeShownOnPackageCustomId: {
      type: String,
      default: '',
    },
    isShipmentInEdit: {
      type: Boolean,
      default: false,
    },
    showColliAmount: {
      type: Boolean,
      default: false,
    },
    showColliDescription: {
      type: Boolean,
      default: true,
    },
    showColliContent: {
      type: Boolean,
      default: false,
    },
    showTemperature: {
      type: Boolean,
      default: false,
    },
    showDangerousGoods: {
      type: Boolean,
      default: false,
    },
    customId: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: 'Parcel',
    },
    removable: {
      type: Boolean,
      default: false,
    },
    showOnlyDescription: {
      type: Boolean,
      default: false,
    },
    showOrigin: {
      type: Boolean,
      default: false,
    },
    showCustoms: {
      type: Boolean,
      default: false,
    },
    indexNo: {
      type: String
    },
    value: {
      type: Object,
      default: () => {
        return{
          goodsType: 1,
          colli: 1,
          description: '',
          parcelType: '',
          packagingName: '',
          colliWeight: {
            value: 0,
            unit: 'kg',
          },
          dimensions: {
            width: {
              value: 0,
              disabled: false,
            },
            height: {
              value: 0,
              disabled: false,
            },
            length: {
              value: 0,
              disabled: false,
            },
            dimensionsType: '',
          },
          isTemperature: false,
          minTemperature: '',
          maxTemperature: '',
          isDgToggleActive: false,
          qty: 1,
          Q: '',
          packingType: '',
          packingTypeOption: 2,
          isOverpack: 0,
          allPackedInOne: 2,
          iataLimitations: '',
          iataRadioactive: '',
          iataAdditionalInfo: '',
          dangerousGoodsServices: [
            {
              feeWrapperId: null,
              dangerousGoodsId: '',
              nemWeight: {
                unit: 'kg',
                value: null,
              },
              netWeight: {
                unit: 'kg',
                value: null,
              },
              bruttoWeight: {
                unit: 'kg',
                value: null,
              },
              englishTechnicalDesignation: '',
              danishTechnicalDesignation: '',
              iataAutorization: '',
              flashPoint: '',
              segregationGroup: '',
              ems: '',
              notAllInOneQty: '',
              notAllInOneOuterPackaging: '',
              innerPackaging: '',
              innerPackagingQty: '',
              packingInstruction: '',
              isEnvironmentalHazard: false,
              isMarinePollutant: false,
              isLimitedQuantity: false,
              isExceptedQuantity: false
            }
          ],
          content: [
            {
              qty: 1,
              description: '',
              unitWeight: {
                value: '',
                unit: 'kg',
              },
              unitValue: {
                value: '',
                unit: 'dkk',
              },
              hsCode: '',
              origin: '',
            },
          ],
        }
      },
    },
  },
  data() {
    return {
      totalContentAmount: 0,
    }
  },
  computed: {
    ...mapGetters([
      'get_parcel_types',
      'get_editing_shipment',
    ]),
  },
  mounted() {
    this.totalContentAmount = this.calculateTotalContentAmount(this.value.content);
  },
  methods: {
    parcelTypeSelected(val) {
      const index = parseInt(this.indexNo)
      if (this.get_editing_shipment?.storeShipmentPackages[index]?.dimensions) {
        const width = this.get_editing_shipment?.storeShipmentPackages[index]?.dimensions.width.value;
        const height = this.get_editing_shipment?.storeShipmentPackages[index]?.dimensions.height.value;
        const length = this.get_editing_shipment?.storeShipmentPackages[index]?.dimensions.length.value;
        const weight = this.get_editing_shipment?.storeShipmentPackages[index]?.colliWeight.value;

        if (this.shouldUseShipmentMeasure(width)) {
          val.width = width;
        }

        if (this.shouldUseShipmentMeasure(height)) {
          val.height = height;
        }

        if (this.shouldUseShipmentMeasure(length)) {
          val.length = length;
        }

        if (this.shouldUseShipmentMeasure(weight)) {
          val.weight = weight;
        }
      }

      //Should not be executed on copy or draft shipment initially, only when user change packaging value
      this.$emit('input', {
        ...this.value,
        parcelType: val.name,
        packagingName: val.packagingName,
        dimensions: {
          width: {
            value: val.width && parseFloat(val.width) > 0 ? val.width : this.value.dimensions.width.value,
            disabled: false,
          },
          height: {
            value: val.height && parseFloat(val.height) > 0 ? val.height : this.value.dimensions.height.value,
            disabled: false,
          },
          length: {
            value: val.length && parseFloat(val.length) > 0 ? val.length : this.value.dimensions.length.value,
            disabled: false,
          },
          dimensionsType: val.dimension_measure ? val.dimension_measure : this.value.dimensions.dimensionsType
        },
        colliWeight: {
          value: val.weight && parseFloat(val.weight) > 0 ? val.weight : this.value.colliWeight.value,
          unit: val.weight_measure && parseFloat(val.weight) > 0  ? val.weight_measure : this.value.colliWeight.unit,
        },
      });
    },
    activeGoodsType(val) {
      this.$emit('activePackageGoodsType', val);
    },
    addContentItem(){
      let weightUnit = 'kg';
      let currencyUnit = 'dkk';
      if (this.value.content.length) {
        weightUnit = this.value.content[0].unitWeight.unit;
        currencyUnit = this.value.content[0].unitValue.unit;
      }

      this.$emit('input', {
        ...this.value,
        content: [...this.value.content, {
          qty: 1,
          description: '',
          unitWeight: {
            value: '',
            unit: weightUnit,
          },
          unitValue: {
            value: '',
            unit: currencyUnit,
          },
          hsCode: '',
          origin: '',
        }]
      });
    },
    removeParcel() {
      this.$emit('removeParcel');
    },
    deleteContentRow(index) {
      const obj = JSON.parse(JSON.stringify(this.value))
      const contentArray = obj.content.filter((item, idx) => idx !== index)

      this.$emit('input', {
        ...obj,
        content: contentArray,
      });
    },
  },
  watch: {
    'showColliContent' (newVal, oldVal) {
      if (this.value && newVal && this.value.content.length < 1) {
        this.addContentItem()
      }
    },
    'value.content': {
      handler(newVal){
        if (newVal) {
          this.totalContentAmount = this.calculateTotalContentAmount(newVal);
        }
      },
      deep: true
    },
  }
}
</script>
